import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import ReactMarkdown from 'react-markdown'
import { swedishTermsOfService } from '@/lib/termsOfService'

export function TermsOfServicePage() {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100">
      {/* Main Content */}
      <main className="px-6 py-12 lg:px-8">
        <div className="mx-auto max-w-4xl">
          {/* Back Button */}
          <Button
            variant="ghost"
            onClick={handleBack}
            className="mb-6 -ml-2"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Tillbaka
          </Button>

          {/* Content Card */}
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <div className="prose prose-lg prose-gray max-w-none
              prose-headings:text-gray-900
              prose-h1:text-3xl prose-h1:font-bold prose-h1:mb-6
              prose-h2:text-2xl prose-h2:font-semibold prose-h2:mt-10 prose-h2:mb-4
              prose-h3:text-xl prose-h3:font-semibold prose-h3:mt-6 prose-h3:mb-3
              prose-p:text-gray-700 prose-p:leading-relaxed
              prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline
              prose-strong:text-gray-900 prose-strong:font-semibold
              prose-ul:my-4 prose-li:text-gray-700
              prose-hr:my-8 prose-hr:border-gray-200
            ">
              <ReactMarkdown>{swedishTermsOfService}</ReactMarkdown>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="mt-8 text-center text-sm text-gray-600">
            <p>
              Har du frågor om användarvillkoren?{' '}
              <a href="mailto:julius@baerell.com" className="text-blue-600 hover:underline">
                Kontakta oss
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
